import { Routes, Route } from 'react-router-dom';
import { KmsLayout } from './layouts';
import { KmsPage } from './pages/KmsPage';
import SpaceListPage from './pages/SpaceListPage';
import CreateSpacePage from './pages/CreateSpacePage';
import SpaceDetailPage from './pages/SpaceDetailPage';
import SpaceEditPage from './pages/SpaceEditPage';
import SpaceChatPage from './pages/SpaceChatPage';
import IntegrationsPage from './pages/IntegrationsPage';
import SlackIntegrationDetailPage from './pages/SlackIntegrationDetailPage';
import DriveOAuthCallbackPage from './pages/DriveOAuthCallbackPage';
import WidgetEmbedPage from './widget/pages/WidgetEmbedPage';
import WidgetListPage from './pages/WidgetListPage';
import CreateWidgetPage from './pages/CreateWidgetPage';
import EditWidgetPage from './pages/EditWidgetPage';
import WidgetDetailPage from './pages/WidgetDetailPage';
import SpaceWidgetEmbedPage from './pages/SpaceWidgetEmbedPage';
import SpaceWidgetAssociationPage from './pages/SpaceWidgetAssociationPage';

export function KmsRoutes() {
  return (
    <>
      {/* Widget embed route - renders standalone without app layout */}
      <Routes>
        <Route path="/widget/embed" element={<WidgetEmbedPage />} />
      </Routes>

      {/* All other routes wrapped with KmsLayout */}
      <KmsLayout>
        <Routes>
          <Route path="/" element={<KmsPage />} />
          <Route path="/spaces" element={<SpaceListPage />} />
          <Route path="/spaces/create" element={<CreateSpacePage />} />
          <Route path="/spaces/:id" element={<SpaceDetailPage />} />
          <Route path="/spaces/:id/edit" element={<SpaceEditPage />} />
          <Route path="/spaces/:id/chat" element={<SpaceChatPage />} />
          <Route path="/spaces/:id/widgets" element={<SpaceWidgetAssociationPage />} />
          <Route path="/spaces/:id/widgets-embed" element={<SpaceWidgetEmbedPage />} />
          <Route path="/widgets" element={<WidgetListPage />} />
          <Route path="/widgets/create" element={<CreateWidgetPage />} />
          <Route path="/widgets/:widgetId" element={<WidgetDetailPage />} />
          <Route path="/widgets/:widgetId/edit" element={<EditWidgetPage />} />
          <Route path="/integrations" element={<IntegrationsPage />} />
          <Route path="/integrations/slack/:id" element={<SlackIntegrationDetailPage />} />
          <Route path="/storage/oauth-callback" element={<DriveOAuthCallbackPage />} />
        </Routes>
      </KmsLayout>
    </>
  );
}
